var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleeveless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,117h-76c-0.55,0-1-0.45-1-1V44c0-0.23,0.08-0.45,0.22-0.62c5.02-6.27,7.78-14.15,7.78-22.18V4 c0-0.55,0.45-1,1-1h17.36c0.39,0,0.74,0.22,0.9,0.57C48.93,8.15,53.43,11,58.5,11s9.57-2.85,11.74-7.43 C70.4,3.22,70.75,3,71.14,3H88.5c0.55,0,1,0.45,1,1v17.19c0,8.03,2.76,15.91,7.78,22.18c0.14,0.18,0.22,0.4,0.22,0.62v72 C97.5,116.55,97.05,117,96.5,117z M21.5,115h74V44.35c-5.16-6.58-8-14.79-8-23.15V5H71.76c-2.59,4.95-7.62,8-13.26,8 S47.83,9.95,45.24,5H29.5v16.19c0,8.37-2.84,16.58-8,23.15V115z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.5,29c-8.27,0-15-6.73-15-15V4c0-0.55,0.45-1,1-1h1.36c0.39,0,0.74,0.22,0.9,0.57 C48.93,8.15,53.43,11,58.5,11s9.57-2.85,11.74-7.43C70.4,3.22,70.75,3,71.14,3h1.36c0.55,0,1,0.45,1,1v10 C73.5,22.27,66.77,29,58.5,29z M45.5,5.47V14c0,7.17,5.83,13,13,13s13-5.83,13-13V5.47c-2.66,4.67-7.54,7.53-13,7.53 S48.16,10.15,45.5,5.47z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeveless);
export default __webpack_public_path__ + "static/media/sleeveless.7c8f29a7b1ed0c94f49c0b1b6a2b77d1.svg";
export { ForwardRef as ReactComponent };